import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Placeholder from './Placeholder.jsx';
import styles from './ObservationItem.module.css';
import SmallStat from './SmallStat.jsx';

function ObservationItem({label, icon, primaryValue, secondaryValue = false, unit = false}) {
  return (
    <div className={styles.ObservationItem} >
      <div className={styles.ObservationIconBox}>
        <FontAwesomeIcon icon={icon} className={styles.ObservationIcon} size="2xl" />
      </div>
      <div className={styles.ObservationTextArea}>
        <h6 className={styles.ObservationTitle}>{label}</h6>
        <SmallStat stat={Number.isFinite(primaryValue) ? primaryValue.toFixed(1) : primaryValue} unit={unit} secondStat={secondaryValue} />
      </div>
    </div>
  )
}

export default ObservationItem;
